var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDistributorReportsIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66.401 64.141",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_report_1123002_000000",
    transform: "matrix(1, 0, 0, 1, -1, -2.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    className: "reports-progress-fill",
    "data-name": "Path 5653",
    d: "M63.993,41.152a22.953,22.953,0,1,0-17.106,7.667,22.792,22.792,0,0,0,8.348-1.578l4.794,10.848h0a7.677,7.677,0,0,0,4.958,4.29,6.1,6.1,0,0,0,.718.162v0a7.7,7.7,0,0,0,6.727-13.078ZM43.322,45.119a19.681,19.681,0,1,1,18.523-6.645,19.668,19.668,0,0,1-18.523,6.645ZM71.39,55.308A4.324,4.324,0,0,1,66.3,59.18l-.408-.1h0a4.3,4.3,0,0,1-2.786-2.413L58.272,45.754q.862-.5,1.687-1.065t1.6-1.221l8.528,8.382a4.306,4.306,0,0,1,1.3,3.456Z",
    transform: "translate(-7.336 0)",
    fill: "#f0997a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    className: "reports-primary-fill",
    "data-name": "Path 5654",
    d: "M15.36,69.229a1.688,1.688,0,0,0,1.194.5H40.907a4.745,4.745,0,0,0,4.746-4.746V58.341a1.7,1.7,0,0,0-3.39,0v6.618a1.356,1.356,0,0,1-1.356,1.356H19.036V55.663A3.967,3.967,0,0,0,15.077,51.7H4.39V16.386A1.355,1.355,0,0,1,5.746,15.03h7.31a1.7,1.7,0,0,0,0-3.39H5.746A4.745,4.745,0,0,0,1,16.386v37.8a1.688,1.688,0,0,0,.5,1.194Zm.313-13.56v9.1l-9.7-9.7h9.108a.589.589,0,0,1,.588.591Z",
    transform: "translate(0 -2.877)",
    fill: "#725d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    className: "reports-primary-fill",
    "data-name": "Path 5655",
    d: "M65.09,33.5V27.359A1.686,1.686,0,0,0,63.4,25.672H57.267a1.7,1.7,0,0,0,0,3.39H59.3l-5.993,6.012-5.3-5.3a1.691,1.691,0,0,0-2.386,0l-7.98,7.975a1.688,1.688,0,1,0,2.386,2.386l6.78-6.78,5.3,5.3a1.686,1.686,0,0,0,2.386,0l7.228-7.219V33.47a1.7,1.7,0,0,0,3.39,0Z",
    transform: "translate(-11.627 -7.395)",
    fill: "#725d7b"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDistributorReportsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/distributorReportsIcon.8391d71d.svg";
export { ForwardRef as ReactComponent };